<template>
    <div class="uk-align-center uk-background-muted " style="margin-top: 0px; margin-bottom: 0px; padding-bottom: 30px">
        <div class="uk-container uk-container-small" style="margin-top: 15px">
           <div class="uk-container uk-container-small uk-hidden@l">
             <div class=" applybtn " id="applybtn" style="text-align: center">
               <a href="https://apply.ncu.edu.jm" target="_blank"
                  class="uk-text-uppercase uk-light uk-button upSize "
                  style="background: #033860 ; color: rgb(255, 215, 3); border-radius: 5px; font-weight: bold; padding-left: 15px; padding-right: 15px; "
               >Apply Now</a>
             </div>
           </div>
            <div class="uk-card uk-card-default uk-card-body">
                <div class="uk-child-width-1-2@m" uk-grid>

                    <div class="uk-text-left">
                        <h3 class="uk-text-left">Academics</h3>
                        <hr>
                        <p class="uk-text-left">
                            Transform your life with a NCU Education. Our degrees will create a platform for your push to making a change in this world.
                        </p><br>
                        <router-link to="/generaladmission" class="uk-button uk-button-secondary uk-text-bold uk-text-capitalize"
                                     style="margin-top: -10px; background-color: rgba(255, 215, 3,0.9); border-radius: 20px; color: #033860; font-size: 22px; font-variant: all-small-caps"
                        >
                            Admissions
                        </router-link>
                        <br>
                        <br>
                        <router-link to="/graduatestudies" class="uk-button uk-button-secondary uk-text-bold uk-text-capitalize"
                           style="margin-top: -10px; background-color: rgba(255, 215, 3,0.9); border-radius: 20px; color: #033860; font-size: 22px; font-variant: all-small-caps"
                        >
                            Graduate Studies
                        </router-link>
<!--                        <br><br>
                        <a href="https://ncu.edu.jm/brobook/" class="uk-button uk-button-secondary uk-text-bold uk-text-capitalize"
                           style="margin-top: -10px; background-color: rgba(255, 215, 3,0.9); border-radius: 20px; color: #033860; font-size: 20px; font-variant: all-small-caps"
                           target="_blank"
                        >
                          Undergraduate Programmes Booklet
                        </a>-->
                        <br><br>
                        <a href="#modal-media-image" class="uk-button uk-button-secondary uk-text-bold uk-text-capitalize"
                           style="margin-top: -10px; background-color: rgba(255, 215, 3,0.9); border-radius: 20px; color: #033860; font-size: 22px; font-variant: all-small-caps" uk-toggle>
                            Frequently Called Extensions
                        </a>

                      <!-- This is the modal -->
                      <div id="modal-media-image" class="uk-flex-top" uk-modal>
                        <div class="uk-modal-dialog  uk-margin-auto-vertical">
                          <button class="uk-modal-close-outside" type="button" uk-close></button>
                          <img src="../../assets/extension.jpg" width="1200" height="900" alt="">
                          <img src="../../assets/extension2.jpg" width="1200" height="900" alt="">
                        </div>
                      </div>
                        <br><br>


                    </div>
                    <div class="uk-text-left">
                        <h3 class="uk-text-left">Points of Pride</h3>
                        <hr>
                        <p class="uk-text-left">
                            We believe in the future and we embrace it by doing what we can today. Join our growing success.
                        </p>
                        <br>
                        <router-link to="/accreditation" class="uk-button uk-button-secondary uk-text-bold uk-text-capitalize"
                                     style="margin-top: -10px; background-color: rgba(255, 215, 3,0.9); border-radius: 20px; color: #033860; font-size: 22px; font-variant: all-small-caps"
                        >
                            Accreditation
                        </router-link>

                        <br><br>
                        <a href="https://aeorion.ncu.edu.jm" target="_blank" class="uk-button uk-button-secondary uk-text-bold uk-text-capitalize"
                           style="margin-top: -10px; background-color: rgba(255, 215, 3,0.9); border-radius: 20px; color: #033860; font-size: 22px; font-variant: all-small-caps"
                        >
                            Aeorion LMS
                        </a>
                        <br><br>
                        <router-link to="/alumni" class="uk-button uk-button-secondary uk-text-bold uk-text-capitalize"
                                     style="margin-top: -10px; background-color: rgba(255, 215, 3,0.9); border-radius: 20px; color: #033860; font-size: 22px; font-variant: all-small-caps"
                        >
                            Alumni
                        </router-link>
                        <br><br>
                        <router-link to="/scholarshipandstudentaid" class="uk-button uk-button-secondary uk-text-bold uk-text-capitalize"
                           style="margin-top: -10px; background-color: rgba(255, 215, 3,0.9); border-radius: 20px; color: #033860; font-size: 22px; font-variant: all-small-caps"
                        >
                            Student Aid
                        </router-link>
                        <br><br>




                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "callToAction"
    }
</script>

<style scoped>
    h3{
        color: #333;
        font-family: soleil, sans-serif !important;
        font-style: normal;
        font-weight: 600;
    }

    @media screen and (max-width:600px){


        h3{
            font-size: 1.1em !important;
        }
        p{
            font-size: 0.7em !important;
        }
        a{
            font-size: 0.9em !important;
        }


    }
    .applybtn{
      padding: 20px;

    }

    @media screen and (min-width: 500px) {
      #applybtn{ display: none;}
    }
</style>
